const _require = require('@truqc/content-path'),
  enumerateWildcardPath = _require.enumerateWildcardPath,
  mutateContentValue = _require.mutateContentValue;

/**
  * @function evalute - evaluate formCollectionBehavior
  */

const evaluate = async (source, contentIn, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const formTypeIdentifier = await sourceEvaluator(source.formTypeIdentifier);
  if (formTypeIdentifier === undefined) {
    return undefined;
  }
  const excluding = await sourceEvaluator(source.excluding);
  const jobFormID = await sourceEvaluator(source.jobFormID);
  const keep = (await sourceEvaluator(source.keep)) || [];
  if (!keep.includes('title')) {
    keep.push('title');
  }
  const querySource = {
    type: 'queryEntityBehavior',
    entityName: 'Form',
    properties: ['content'],
    equals: {
      'formType/identifier': formTypeIdentifier
    }
  };
  if (excluding !== undefined) {
    querySource.equalsNoneOf = {
      id: excluding
    };
  }
  const retrievedForms = await sourceEvaluator(querySource);
  if (retrievedForms === undefined) {
    return undefined;
  }
  const collection = {};
  retrievedForms.forEach((form, index) => {
    const id = form.id,
      contentString = form.content;
    const content = JSON.parse(contentString);
    const _content$job = content.job,
      job = _content$job === void 0 ? {} : _content$job;
    if (jobFormID !== undefined && Object.keys(job)[0] === jobFormID) {
      const item = {
        _created: index
      };
      keep.forEach(wildcardPath => {
        enumerateWildcardPath(content, wildcardPath, (path, value) => {
          mutateContentValue(path, item, value);
        });
      });
      collection[id] = item;
    }
  });
  return collection;
};
module.exports = {
  evaluate
};